var $c41069c0ec2e8139$exports = {};
// A switch is the only button that is a field's control.
const $c41069c0ec2e8139$var$SWITCH = 'button[role="switch"]';
// A select's trigger is a span, so `for` cannot reach it and aria-labelledby
// is the whole name.
const $c41069c0ec2e8139$var$COMBOBOX = '[role="combobox"]';
const $c41069c0ec2e8139$var$LABELABLE = `input:not([type="hidden"]), select, textarea, ${$c41069c0ec2e8139$var$SWITCH}, ${$c41069c0ec2e8139$var$COMBOBOX}`;
const $c41069c0ec2e8139$var$ERRORS = '[data-form-error]';
const $c41069c0ec2e8139$var$HELP = '.form-group__help';
const $c41069c0ec2e8139$var$LABEL = '[data-field-label]';
const $c41069c0ec2e8139$var$LABEL_TEXT = '[data-field-label-text]';
const $c41069c0ec2e8139$var$REQUIRED = 'data-field-required';
const $c41069c0ec2e8139$var$REQUIRED_MARKER = '[data-field-required-marker]';
const $c41069c0ec2e8139$var$INSIDE_A_MENU = '[role="listbox"], [role="menu"]';
const $c41069c0ec2e8139$var$TRIGGER = '[aria-haspopup="listbox"]';
const $c41069c0ec2e8139$var$NAMED = 'data-field-named';
const $c41069c0ec2e8139$var$GROUP = '[data-form-group]';
const $c41069c0ec2e8139$var$OWNER = `elm-field, ${$c41069c0ec2e8139$var$GROUP}`;
let $c41069c0ec2e8139$var$fieldIds = 0;
let $c41069c0ec2e8139$var$descriptionIds = 0;
const $c41069c0ec2e8139$var$added = new WeakMap();
const $c41069c0ec2e8139$var$flagged = new WeakSet();
function $c41069c0ec2e8139$var$describe(control, descriptions) {
    const ours = $c41069c0ec2e8139$var$added.get(control) ?? [];
    $c41069c0ec2e8139$var$added.set(control, descriptions);
    const ids = [
        ...new Set((control.getAttribute('aria-describedby') ?? '').split(' ').filter((id)=>id && !ours.includes(id)).concat(descriptions))
    ];
    if (ids.length === 0) control.removeAttribute('aria-describedby');
    else control.setAttribute('aria-describedby', ids.join(' '));
}
function $c41069c0ec2e8139$var$unname(control) {
    if (control.hasAttribute($c41069c0ec2e8139$var$NAMED)) {
        control.removeAttribute('aria-labelledby');
        control.removeAttribute($c41069c0ec2e8139$var$NAMED);
    }
}
class $c41069c0ec2e8139$var$ElmField extends HTMLElement {
    connectedCallback() {
        this.fieldId ??= `elm-field-${++$c41069c0ec2e8139$var$fieldIds}`;
        this.wire();
        this.observer = new MutationObserver(()=>this.wire());
        const changes = {
            childList: true,
            subtree: true
        };
        [
            this,
            ...this.groups()
        ].forEach((node)=>this.observer.observe(node, changes));
    }
    disconnectedCallback() {
        this.observer.disconnect();
    }
    own(selector) {
        return [
            ...this.querySelectorAll(selector)
        ].filter((el)=>el.closest('elm-field') === this);
    }
    descriptions() {
        return this.own(`${$c41069c0ec2e8139$var$ERRORS}, ${$c41069c0ec2e8139$var$HELP}`).filter((node)=>node.closest($c41069c0ec2e8139$var$OWNER) === this);
    }
    groups() {
        const groups = [];
        let owner = this.parentElement?.closest($c41069c0ec2e8139$var$OWNER);
        while(owner?.matches($c41069c0ec2e8139$var$GROUP)){
            groups.push(owner);
            owner = owner.parentElement?.closest($c41069c0ec2e8139$var$OWNER);
        }
        return groups;
    }
    groupErrors() {
        return this.groups().flatMap((group)=>[
                ...group.querySelectorAll($c41069c0ec2e8139$var$ERRORS)
            ].filter((node)=>node.closest($c41069c0ec2e8139$var$OWNER) === group));
    }
    describedBy(node, controls) {
        for(let el = node.parentElement; el; el = el.parentElement){
            const within = controls.filter((control)=>el.contains(control));
            if (within.length === 1) return within;
            if (within.length > 1) return controls;
            if (el === this) break;
        }
        return controls;
    }
    wire() {
        const labelable = this.own($c41069c0ec2e8139$var$LABELABLE).filter((el)=>!el.closest($c41069c0ec2e8139$var$INSIDE_A_MENU));
        const triggers = this.own($c41069c0ec2e8139$var$TRIGGER);
        const trigger = labelable.length === 0 && triggers.length === 1 ? triggers[0] : null;
        const controls = trigger ? [
            trigger
        ] : labelable;
        const described = new Map(controls.map((control)=>[
                control,
                []
            ]));
        const invalid = new Set();
        this.descriptions().forEach((node)=>{
            node.id ||= `elm-description-${++$c41069c0ec2e8139$var$descriptionIds}`;
            this.describedBy(node, controls).forEach((control)=>{
                described.get(control).push(node.id);
                if (node.matches($c41069c0ec2e8139$var$ERRORS)) invalid.add(control);
            });
        });
        const groupErrors = this.groupErrors();
        groupErrors.forEach((node)=>{
            node.id ||= `elm-description-${++$c41069c0ec2e8139$var$descriptionIds}`;
        });
        controls.forEach((control)=>{
            groupErrors.forEach((node)=>described.get(control).push(node.id));
            if (groupErrors.length > 0) invalid.add(control);
        });
        controls.forEach((control)=>$c41069c0ec2e8139$var$describe(control, described.get(control)));
        [
            ...labelable,
            ...triggers
        ].forEach((control)=>{
            if (invalid.has(control)) {
                if (control.getAttribute('aria-invalid') !== 'true') {
                    control.setAttribute('aria-invalid', 'true');
                    $c41069c0ec2e8139$var$flagged.add(control);
                }
            } else if ($c41069c0ec2e8139$var$flagged.delete(control)) control.removeAttribute('aria-invalid');
        });
        // On a group, aria-required would mark its optional parts required too.
        const marker = this.own($c41069c0ec2e8139$var$REQUIRED_MARKER)[0];
        const onControl = this.hasAttribute($c41069c0ec2e8139$var$REQUIRED) && labelable.length === 1;
        labelable.forEach((control)=>control.removeAttribute('aria-required'));
        if (onControl) {
            labelable[0].setAttribute('aria-required', 'true');
            marker?.setAttribute('aria-hidden', 'true');
        } else marker?.removeAttribute('aria-hidden');
        const [label] = this.own($c41069c0ec2e8139$var$LABEL);
        if (!label) {
            this.removeAttribute('role');
            this.removeAttribute('aria-labelledby');
            [
                ...labelable,
                ...triggers
            ].forEach($c41069c0ec2e8139$var$unname);
            return;
        }
        const [labelText] = this.own($c41069c0ec2e8139$var$LABEL_TEXT);
        const nameSource = labelText ?? label;
        nameSource.id ||= `${this.fieldId}-label`;
        const names = [
            nameSource
        ];
        if (marker && !onControl) {
            marker.id ||= `${this.fieldId}-required`;
            names.push(marker);
        }
        if (trigger) {
            label.removeAttribute('for');
            trigger.id ||= `${this.fieldId}-control`;
            const ids = [
                ...names,
                trigger
            ].map((node)=>node.id);
            trigger.setAttribute('aria-labelledby', ids.join(' '));
            trigger.setAttribute($c41069c0ec2e8139$var$NAMED, '');
            this.removeAttribute('role');
            this.removeAttribute('aria-labelledby');
            return;
        }
        triggers.forEach($c41069c0ec2e8139$var$unname);
        triggers.filter((t)=>!controls.includes(t)).forEach((t)=>$c41069c0ec2e8139$var$describe(t, []));
        const [control] = controls;
        if (controls.length === 1 && !control.closest('label')) {
            control.id ||= `${this.fieldId}-control`;
            label.htmlFor = control.id;
            this.removeAttribute('role');
            this.removeAttribute('aria-labelledby');
            // A switch's own name carries why it is disabled.
            if (labelText && !control.matches($c41069c0ec2e8139$var$SWITCH)) {
                control.setAttribute('aria-labelledby', labelText.id);
                control.setAttribute($c41069c0ec2e8139$var$NAMED, '');
            } else $c41069c0ec2e8139$var$unname(control);
        } else {
            label.removeAttribute('for');
            this.setAttribute('role', 'group');
            this.setAttribute('aria-labelledby', names.map((node)=>node.id).join(' '));
            controls.forEach($c41069c0ec2e8139$var$unname);
        }
    }
}
if (!customElements.get('elm-field')) customElements.define('elm-field', $c41069c0ec2e8139$var$ElmField);


//# sourceMappingURL=provider-portal.c9824aac.js.map
